import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { StylesProvider, createGenerateClassName } from '@mui/styles';
import { SnackbarProvider } from 'notistack';
import type { ReactNode } from 'react';
import { I18nextProvider } from 'react-i18next';
import { ThemeProvider } from 'styled-components';

import { useClarity } from '@woovi/clarity';
import {
  SnackbarProvider as SnackbarProviderUI,
  ThemeMuiTheme,
} from '@woovi/ui';

import PluginApp from './PluginApp.tsx';
import { config } from '../config.tsx';
import i18n from '../i18n/i18n.tsx';
import { SentryErrorBoundary } from '../sentry/SentryErrorBoundary.ts';
import OpenPixProvider from '../store/OpenPixProvider.tsx';

export const generateClassName = createGenerateClassName({
  productionPrefix: 'openpix',
});

const PluginRoot = (): ReactNode => {
  useClarity({
    clarityId: config.CLARITY_ID,
  });

  return (
    <SentryErrorBoundary>
      <OpenPixProvider>
        <StylesProvider injectFirst generateClassName={generateClassName}>
          <SnackbarProviderUI>
            <SnackbarProvider>
              <ThemeProvider theme={ThemeMuiTheme}>
                <StyledEngineProvider injectFirst>
                  <MuiThemeProvider theme={ThemeMuiTheme}>
                    <I18nextProvider i18n={i18n}>
                      <CssBaseline />
                      <PluginApp />
                    </I18nextProvider>
                  </MuiThemeProvider>
                </StyledEngineProvider>
              </ThemeProvider>
            </SnackbarProvider>
          </SnackbarProviderUI>
        </StylesProvider>
      </OpenPixProvider>
    </SentryErrorBoundary>
  );
};

export default PluginRoot;
